import { render, staticRenderFns } from "./ResearcherNow.vue?vue&type=template&id=f72de648&"
import script from "./ResearcherNow.vue?vue&type=script&lang=js&"
export * from "./ResearcherNow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports